import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Shirdilocalsightseeingcab() {



    const cardData = {





keyword: "Shirdi Local Sightseeing Cabs",
headingDescription: "Sai Shirdi Cab provides convenient local sightseeing cabs in Shirdi for devotees, families, senior citizens, couples, and groups who want to explore important religious and nearby sightseeing destinations in a comfortable taxi. A local sightseeing cab makes it easier to cover multiple places in a planned itinerary without depending on public transport or arranging separate vehicles for every stop. Customers can choose a suitable cab based on their passenger count, luggage, and sightseeing requirements, with flexible pickup and drop arrangements from hotels, railway station areas, or other convenient points in Shirdi. Sai Shirdi Cab can arrange short local tours, half-day sightseeing, full-day sightseeing, and customized Shirdi sightseeing packages according to the travel schedule. The service is suitable for visitors arriving for Sai Baba darshan as well as families and groups who want to explore the spiritual and cultural attractions around Shirdi in a well-organized manner.",

topPlaces: [
{
title: "Sai Baba Temple",
description: "Sai Baba Temple is the main attraction for devotees visiting Shirdi and is generally the central point of a local sightseeing itinerary. With Sai Shirdi Cab, visitors can arrange convenient local transportation around their darshan schedule and combine the temple visit with other important places in Shirdi. A private sightseeing cab helps families and groups manage their local travel comfortably without relying on multiple transport options."
},
{
title: "Dwarkamai",
description: "Dwarkamai is an important spiritual place associated with Sai Baba and is commonly included in Shirdi sightseeing plans. Visitors can book a local cab through Sai Shirdi Cab to travel conveniently between Dwarkamai and other nearby religious attractions. The sightseeing journey can be organized according to the group's preferred timing, making it suitable for families, senior citizens, and devotees."
},
{
title: "Chavadi",
description: "Chavadi is a significant religious landmark in Shirdi and can be included in a local sightseeing cab itinerary along with other Sai Baba-related places. Sai Shirdi Cab provides convenient transportation for visitors who want to cover several attractions during their stay. A planned cab service makes local movement easier, particularly for families and groups visiting Shirdi for a short duration."
},
{
title: "Gurusthan",
description: "Gurusthan is another important spiritual location for devotees exploring Shirdi. Travelers can include the site in their local sightseeing itinerary and use Sai Shirdi Cab for convenient transportation between different attractions. The cab service can be arranged as part of a half-day or full-day sightseeing plan, allowing visitors to cover important places without worrying about local transportation."
},
{
title: "Khandoba Temple",
description: "Khandoba Temple is an important religious attraction associated with the history of Shirdi and can be covered during a local sightseeing tour. Sai Shirdi Cab can arrange comfortable local transportation for devotees and families who want to visit the temple along with other nearby attractions. Flexible cab arrangements make it easier to organize the sightseeing sequence according to the group's available time."
},
{
title: "Lendi Baug",
description: "Lendi Baug is a peaceful and historically significant location connected with Sai Baba and is suitable for visitors looking to explore Shirdi's spiritual heritage. Sai Shirdi Cab can include Lendi Baug in a customized local sightseeing route covering multiple attractions. Private cab travel provides convenient transportation for families, elderly passengers, and groups moving between sightseeing points."
},
{
title: "Shani Shingnapur",
description: "Shani Shingnapur can be added to a broader sightseeing itinerary for visitors staying in Shirdi who want to explore an important nearby pilgrimage destination. Sai Shirdi Cab can arrange a private cab for passengers who wish to combine Shirdi local sightseeing with this religious visit. The itinerary can be planned as a convenient extended sightseeing trip with suitable pickup and return arrangements."
},
{
title: "Sakori",
description: "Sakori is a nearby spiritual destination that can be included in a customized sightseeing plan from Shirdi. Visitors who have additional time after their Shirdi darshan can book a cab through Sai Shirdi Cab to explore the destination comfortably. The route can be arranged according to the passenger's preferred departure time, sightseeing duration, and return schedule."
},
{
title: "Wet N Joy Water Park",
description: "Wet N Joy Water Park is a leisure attraction that can be included in a Shirdi local travel plan, especially for families traveling with children. Sai Shirdi Cab can provide convenient local transportation for visitors who want to combine religious sightseeing with recreational activities. A private cab allows families to plan their sightseeing and leisure stops according to their own schedule."
},
{
title: "Panchavati",
description: "Panchavati in Nashik can be included as an extended sightseeing option for travelers who have more time beyond Shirdi's local attractions. Sai Shirdi Cab can arrange private transportation for visitors interested in combining their Shirdi pilgrimage with a wider religious sightseeing itinerary. The journey can be customized with planned stops and return travel according to the group's requirements."
}
]
,








"services": [
{
"name": "Shirdi Local Sightseeing Cabs",
"description": "Explore the important religious and local attractions of Shirdi comfortably with Sai Shirdi Cabs. Our local sightseeing cabs offer convenient travel for devotees, families, and visitors looking to cover multiple places in and around Shirdi."
},
{
"name": "Shirdi Local Sightseeing Taxi",
"description": "Sai Shirdi Cabs provides reliable local sightseeing taxis for visiting popular temples and attractions around Shirdi. Enjoy a comfortable journey with flexible travel options suitable for short visits as well as complete sightseeing plans."
},
{
"name": "Shirdi sightseeing cab service",
"description": "Our Shirdi sightseeing cab service is designed for travelers who want to explore the city's spiritual and nearby attractions without transportation hassles. Choose a suitable cab and enjoy convenient point-to-point travel throughout your sightseeing schedule."
},
{
"name": "Shirdi sightseeing taxi service",
"description": "Book a Shirdi sightseeing taxi service with Sai Shirdi Cabs for comfortable and well-planned local travel. Our taxis make it easier to visit temples, religious landmarks, and popular sightseeing spots while keeping your trip convenient and stress-free."
},
{
"name": "Shirdi local cab service",
"description": "Sai Shirdi Cabs offers a dependable Shirdi local cab service for temple visits, hotel transfers, shopping, and local sightseeing. Our cabs provide a practical travel solution for individuals, families, and groups exploring Shirdi."
},
{
"name": "Shirdi local taxi service",
"description": "Travel around Shirdi with our convenient local taxi service, ideal for devotees and tourists visiting different attractions during their stay. Sai Shirdi Cabs focuses on comfortable rides, easy booking, and flexible local travel requirements."
},
{
"name": "Shirdi local sightseeing cab booking",
"description": "Make your Shirdi trip easier with quick local sightseeing cab booking from Sai Shirdi Cabs. Plan visits to important temples and attractions in advance and enjoy comfortable transportation throughout your local sightseeing itinerary."
},
{
"name": "Shirdi sightseeing taxi booking",
"description": "Shirdi sightseeing taxi booking with Sai Shirdi Cabs gives travelers an easy way to arrange transportation for their complete local tour. Our taxi options are suitable for devotees, families, senior citizens, and tourists looking for comfortable sightseeing travel."
},
{
"name": "Shirdi Sai Baba Temple Cab",
"description": "Book a convenient cab for visiting the famous Shirdi Sai Baba Temple and other nearby religious attractions. Sai Shirdi Cabs provides comfortable local transportation to help devotees manage their temple visits and sightseeing plans with ease."
},
{
"name": "Shirdi temple sightseeing taxi",
"description": "Our Shirdi temple sightseeing taxi service helps devotees visit important religious places around Shirdi conveniently. With a dedicated taxi, travelers can cover temple destinations according to their schedule without depending on multiple local transport options."
},
{
"name": "Shirdi to Dwarkamai Cab",
"description": "Sai Shirdi Cabs offers comfortable Shirdi to Dwarkamai cab services for devotees visiting this important spiritual landmark. The cab provides convenient local transportation and can also be combined with other nearby temple and sightseeing destinations."
},
{
"name": "Shirdi to Chavadi Cab",
"description": "Book a Shirdi to Chavadi cab for a comfortable visit to this significant Sai Baba-related religious site. Our local cabs make it convenient for devotees to include Chavadi in their Shirdi sightseeing itinerary along with other nearby attractions."
},
{
"name": "Shirdi to Khandoba Temple Cab",
"description": "Travel conveniently from Shirdi to Khandoba Temple with Sai Shirdi Cabs. Our cab service is suitable for devotees and tourists who want a comfortable local ride while covering Khandoba Temple as part of their Shirdi religious sightseeing tour."
},
{
"name": "Shirdi to Lendi Baug Cab",
"description": "Sai Shirdi Cabs provides comfortable Shirdi to Lendi Baug cab services for devotees exploring important spiritual places in Shirdi. Enjoy convenient local transportation and include Lendi Baug in a personalized temple and sightseeing itinerary."
},
{
"name": "Shirdi to Shani Shingnapur sightseeing cab",
"description": "Plan a convenient Shirdi to Shani Shingnapur sightseeing trip with a dedicated cab from Sai Shirdi Cabs. This option is ideal for devotees who want comfortable transportation between Shirdi and Shani Shingnapur while enjoying a flexible sightseeing schedule."
},
{
"name": "Shirdi local one day cab package",
"description": "Our Shirdi local one day cab package is a convenient option for travelers planning to explore multiple attractions within a single day. Sai Shirdi Cabs provides comfortable transportation for temple visits, local sightseeing, family trips, and customized travel plans."
},
{
"name": "Shirdi local sightseeing tour package",
"description": "Choose a Shirdi local sightseeing tour package from Sai Shirdi Cabs to explore the city's important religious and tourist attractions conveniently. Our sightseeing packages can help families, devotees, and groups cover multiple destinations in a comfortable cab."
},
{
"name": "Shirdi family sightseeing cab",
"description": "Travel comfortably with your family using a dedicated Shirdi family sightseeing cab from Sai Shirdi Cabs. Spacious and convenient cab options make it easier for families to visit temples and local attractions together without the inconvenience of arranging separate rides."
},
{
"name": "Shirdi Ertiga sightseeing cab",
"description": "The Shirdi Ertiga sightseeing cab is a practical choice for families and small groups looking for additional space and comfortable local travel. Sai Shirdi Cabs offers Ertiga cabs for temple visits, sightseeing tours, and customized Shirdi travel plans."
},
{
"name": "Shirdi Innova sightseeing cab",
"description": "Book a Shirdi Innova sightseeing cab for a spacious and comfortable experience while exploring local attractions and religious destinations. Sai Shirdi Cabs offers Innova options suitable for families and groups who prefer a relaxed sightseeing journey around Shirdi."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides reliable local sightseeing, temple visit, and cab booking services in Shirdi for devotees, families, and tourists. From short local transfers to full-day sightseeing packages, we offer comfortable cab options for exploring Shirdi and nearby destinations."
}
],
"tableData": [
["Shirdi Local Sightseeing Cabs", "Shirdi Local Sightseeing Taxi"],
["Shirdi sightseeing cab service", "Shirdi sightseeing taxi service"],
["Shirdi local cab service", "Shirdi local taxi service"],
["Shirdi local sightseeing cab booking", "Shirdi sightseeing taxi booking"],
["Shirdi Sai Baba Temple Cab", "Shirdi temple sightseeing taxi"],
["Shirdi to Dwarkamai Cab", "Shirdi to Chavadi Cab"],
["Shirdi to Khandoba Temple Cab", "Shirdi to Lendi Baug Cab"],
["Shirdi to Shani Shingnapur sightseeing cab", "Shirdi local one day cab package"],
["Shirdi local sightseeing tour package", "Shirdi family sightseeing cab"],
["Shirdi Ertiga sightseeing cab", "Shirdi Innova sightseeing cab"],
["Sai Shirdi Cabs", "Shirdi Local Sightseeing Cabs"]
]
,





whychoose: [  
 
    {   
 
        WhyChooseheading: "Shirdi Local Sightseeing Cabs for Comfortable City Tours",   
 
        WhyChoosedescription: "Sai Shirdi Cabs provides Shirdi Local Sightseeing Cab services for devotees, families, tourists, senior citizens, and groups who want to explore important attractions around Shirdi conveniently. A private cab can be arranged according to your sightseeing plan, preferred pickup location, number of passengers, travel duration, and places you wish to visit during your Shirdi trip."   
 
    },   
 
    {   
 
        WhyChooseheading: "Private Cab for Shirdi Local Sightseeing",   
 
        WhyChoosedescription: "Travellers can book a private cab for exploring Shirdi and nearby sightseeing attractions without depending on multiple local transportation options. Sai Shirdi Cabs can organize local sightseeing transportation according to your selected places, pickup point, passenger requirements, and preferred travel schedule for a more convenient day of local travel."   
 
    },   
 
    {   
 
        WhyChooseheading: "Shirdi Sightseeing Taxi for Families and Devotees",   
 
        WhyChoosedescription: "Families and Sai Baba devotees can choose a private sightseeing taxi when visiting Shirdi with children, senior citizens, or luggage. The cab can be planned around your pilgrimage and sightseeing requirements, allowing your group to travel together between selected attractions while maintaining a schedule that suits your overall Shirdi visit."   
 
    },   
 
    {   
 
        WhyChooseheading: "Cab for Sai Baba Temple and Nearby Attractions",   
 
        WhyChoosedescription: "Visitors can arrange a local cab for visiting the Sai Baba Temple area and other selected attractions around Shirdi. Sai Shirdi Cabs provides transportation that can be coordinated according to your sightseeing route, pickup location, passenger count, and preferred timing, making it easier to combine religious visits with local sightseeing."   
 
    },   
 
    {   
 
        WhyChooseheading: "Full Day Shirdi Local Sightseeing Cab",   
 
        WhyChoosedescription: "Travellers planning several sightseeing stops can arrange a cab for a longer local tour around Shirdi. A full-day sightseeing arrangement can be discussed according to the places you want to cover, number of passengers, starting point, travel schedule, and overall local transportation requirements for the day."   
 
    },   
 
    {   
 
        WhyChooseheading: "Shirdi Sightseeing Cab for Senior Citizens",   
 
        WhyChoosedescription: "Senior citizens visiting Shirdi can benefit from arranging private cab transportation for their local sightseeing plans. Travelling by a private vehicle allows families to coordinate pickups and sightseeing stops according to their planned itinerary, making it easier to manage temple visits and nearby attractions during the Shirdi trip."   
 
    },   
 
    {   
 
        WhyChooseheading: "Custom Shirdi Local Sightseeing Tour by Cab",   
 
        WhyChoosedescription: "Every traveller may have different sightseeing requirements, so passengers can discuss their preferred places with Sai Shirdi Cabs while booking. The local sightseeing cab can be planned around your selected attractions, pickup point, passenger count, available time, and preferred travel sequence for a customized Shirdi sightseeing experience."   
 
    },   
 
    {   
 
        WhyChooseheading: "Book Shirdi Local Sightseeing Cabs with Sai Shirdi Cabs",   
 
        WhyChoosedescription: "To book a Shirdi Local Sightseeing Cab, provide Sai Shirdi Cabs with your pickup location, travel date, preferred sightseeing duration, passenger count, and the attractions you want to visit. Sharing your complete itinerary helps in arranging local transportation according to your sightseeing plans and travel requirements."   
 
    }   
 
]   
 
 
}; 
 
const faqData = [ 
 
{ 
 
question: "Can I book a cab for local sightseeing in Shirdi?", 
 
answer: "Yes, Sai Shirdi Cabs provides local sightseeing cab services in Shirdi for devotees, families, tourists, senior citizens, and groups who want to visit selected local attractions." 
 
}, 
 
{ 
 
question: "Can I book a private taxi for Shirdi sightseeing?", 
 
answer: "Yes, you can book a private taxi for Shirdi local sightseeing according to your preferred pickup location, sightseeing plan, passenger count, and travel schedule." 
 
}, 
 
{ 
 
question: "Can I visit Sai Baba Temple using a Shirdi sightseeing cab?", 
 
answer: "Yes, a local sightseeing cab can be arranged for transportation to the Sai Baba Temple area and other attractions included in your planned Shirdi sightseeing itinerary." 
 
}, 
 
{ 
 
question: "Is full day cab service available for Shirdi sightseeing?", 
 
answer: "Yes, travellers can discuss a longer local sightseeing cab arrangement with Sai Shirdi Cabs based on the number of places they want to visit, travel duration, passenger count, and itinerary." 
 
}, 
 
{ 
 
question: "Can families book Shirdi Local Sightseeing Cabs?", 
 
answer: "Yes, families can book private local sightseeing cabs in Shirdi and provide their passenger count, preferred places, pickup location, and travel schedule while making the booking." 
 
}, 
 
{ 
 
question: "Can senior citizens use a cab for Shirdi sightseeing?", 
 
answer: "Yes, senior citizens and their families can arrange private cab transportation for local sightseeing according to their preferred itinerary, pickup requirements, and sightseeing schedule." 
 
}, 
 
{ 
 
question: "Can I choose the places to visit during Shirdi sightseeing?", 
 
answer: "Yes, you can discuss your preferred sightseeing attractions with Sai Shirdi Cabs while booking so the local cab arrangement can be planned according to your selected itinerary." 
 
}, 
 
{ 
 
question: "Can I book a Shirdi sightseeing cab for a group?", 
 
answer: "Yes, groups can arrange local sightseeing transportation based on the number of passengers, luggage requirements, selected attractions, and preferred vehicle arrangement." 
 
}, 
 
{ 
 
question: "Can I start Shirdi sightseeing from my hotel?", 
 
answer: "Yes, hotel pickup or another suitable location in Shirdi can be discussed while booking the local sightseeing cab, depending on your travel details and service arrangement." 
 
}, 
 
{ 
 
question: "How can I book a Shirdi Local Sightseeing Cab?", 
 
answer: "You can contact Sai Shirdi Cabs with your pickup location, travel date, preferred sightseeing duration, passenger count, selected attractions, and other requirements to arrange your local sightseeing cab booking." 
 
} 
 
]; 
 
const testimonials = [ 
 
{ 
 
id: 1, 
 
name: "Mr. Sandeep Pawar", 
 
feedback: "We booked a Shirdi Local Sightseeing Cab for our family visit. Having a private taxi made it convenient to travel between the temple area and the other places we wanted to explore without arranging separate transportation for every stop.", 
 
rating: 5 
 
}, 
 
{ 
 
id: 2, 
 
name: "Mrs. Kavita Sharma", 
 
feedback: "Our family used Sai Shirdi Cabs for local sightseeing in Shirdi. We shared our preferred places and travel schedule while booking, and the private cab made it easier for everyone to travel together during our pilgrimage and sightseeing day.", 
 
rating: 5 
 
} 
 
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shirdi Local Sightseeing Cabs",
  "image": "https://www.saishirdicabs.com/assets/images/shirdi-local-sightseeing-cabs.webp",
  "description":
    "Book Shirdi Local Sightseeing Cabs with Sai Shirdi Cabs for comfortable, convenient, and reliable local sightseeing in Shirdi. Our sightseeing cab service is suitable for Sai Baba Temple Darshan, Dwarkamai, Chavadi, Khandoba Temple, Shani Shingnapur trips, family sightseeing, and local travel. Get well-maintained cars, professional drivers, flexible pickup and drop locations, affordable fares, and easy booking assistance.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/shirdi-local-sightseeing-cabs"
  }
};




    return (
        <div>

<Helmet>
  <title>Shirdi Local Sightseeing Cabs | Shirdi Sightseeing Taxi | +91 7776814559</title>

  <meta
    name="description"
    content="Book Shirdi Local Sightseeing Cabs with Sai Shirdi Cabs for Sai Baba Temple Darshan, Dwarkamai, Chavadi, Khandoba Temple and local sightseeing. Get comfortable cars, professional drivers and affordable sightseeing fares."
  />

  <meta
    name="keywords"
    content="Shirdi Local Sightseeing Cabs, Shirdi Local Sightseeing Taxi, Shirdi sightseeing cab service, Shirdi sightseeing taxi service, Shirdi local cab service, Shirdi local taxi service, Shirdi sightseeing cab booking, Shirdi sightseeing taxi booking, Shirdi local sightseeing taxi booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/105.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Shirdilocalsightseeingcab;